module.exports = __webpack_public_path__ + "static/decoration-f29db13f6e95a3c35b774022a9cb05eb.jpg";